<template>
  <div>
    <a :href="item.Url" class="info-card info-card--full-height" :class="[featuredCardClass ? 'info-card--horizontal' : '']">
      <div class="info-card__image-frame" :class="[featuredCardClass ? 'info-card__image-frame--featured' : '']">
        <picture class="c-image-frame c-image-frame--border-radius-at-medium" :class="imageModifier" v-if="item.Image">
          <source v-if="item.Image.Crops['1:1 Aspect Ratio Crop']" width="1200" height="1200" :data-srcset="item.Image.Crops['1:1 Aspect Ratio Crop'].SrcSet" media="(max-width: 959px)">
          <img width="1200" height="750" class="c-image-frame__image lazyload" data-sizes="auto" alt="" :data-srcset="item.Image.Crops['16:10 Aspect Ratio Crop'].SrcSet" :data-src="item.Image.Crops['16:10 Aspect Ratio Crop'].Src">
        </picture>
      </div>
      <div class="info-card__content" :class="[featuredCardClass ? 'info-card__content--featured' : '']">
        <div class="info-card__cost">
          <div v-if="item.CostText == 'Special offer'" class="info-card__cost-item">
                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                  viewBox="0 0 190.5 190.5" style="enable-background:new 0 0 190.5 190.5;" xml:space="preserve">
                <g id="Group_245" transform="translate(-1203 -735)">
                  <path id="Path_127" class="st0" fill="#B298B0" d="M1298.2,735c52.6,0,95.2,42.6,95.2,95.2s-42.6,95.2-95.2,95.2s-95.2-42.6-95.2-95.2
                    S1245.6,735,1298.2,735z"/>
                  <g id="noun-discount-1625796" transform="translate(1202.94 743.488) rotate(-30)">
                    <path id="Path_136" fill="#fff"  class="st1" d="M68.3,136.9l0-42.9c0-0.9-0.3-1.7-0.9-2.4L45.6,68.4c-1-1.1-2.4-1.7-3.8-1.7h-2.4
                      c-1.5,0-2.9,0.6-3.8,1.7L13.7,91.6c-0.5,0.7-0.8,1.5-0.9,2.4l0,19.8l-22.2-9.2l-1.4,3.1l51.3,21.3l51.3,21.2l1.4-3.1L68.3,136.9z
                      M40.6,73.6c2.9,0,5.2,2.3,5.2,5.2c0,2.9-2.3,5.2-5.2,5.2c-2.9,0-5.2-2.3-5.2-5.2c-0.1-2.8,2.2-5.2,5-5.2
                      C40.4,73.6,40.5,73.6,40.6,73.6L40.6,73.6z"
                  />
                  <path id="Path_137" fill="#fff" class="st1" d="M12.8,170.7l55.5,0l0-26.4l-55.5-23.1L12.8,170.7z" />
                </g>
              </g>
            </svg>
            <span class="info-card__cost-item-title">{{ item.CostText }}</span>
             
          </div>
          <div v-else-if="item.CostText == 'Discounted day out'" class="info-card__cost-item">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 viewBox="0 0 190.5 190.5" style="enable-background:new 0 0 190.5 190.5;" xml:space="preserve"
            >
              <g id="Group_246" transform="translate(-794 -1411)">
                <path id="Path_119" fill="#B298B0" class="st0" d="M889.3,1411c52.7,0,95.4,42.7,95.4,95.4s-42.7,95.4-95.4,95.4s-95.4-42.7-95.4-95.4
                S836.6,1411,889.3,1411z"
                />
                <g id="noun-offer-2831311" transform="translate(791.983 1410.02)">
                  <path id="Path_108" fill="#fff" class="st1" d="M128.4,60.3l-70.3,70.3c-2.4,2.4-2.4,6.3,0,8.7c2.4,2.4,6.3,2.4,8.7,0.1c0,0,0,0,0.1-0.1
                  L137.1,69c2.4-2.4,2.4-6.3,0-8.7C134.7,57.9,130.8,57.9,128.4,60.3C128.4,60.3,128.4,60.3,128.4,60.3z"
                  />
                  <path id="Path_109" fill="#fff" class="st1" d="M74,87.9c6.4,0,11.6-5.2,11.6-11.6c0-6.4-5.2-11.6-11.6-11.6c-6.4,0-11.6,5.2-11.6,11.6l0,0
                  C62.4,82.7,67.6,87.9,74,87.9C74,87.9,74,87.9,74,87.9z"
                  />
                  <path id="Path_110" fill="#fff" class="st1" d="M121,111.8c-6.4,0-11.6,5.2-11.6,11.6s5.2,11.6,11.6,11.6c6.4,0,11.6-5.2,11.6-11.6
                  C132.6,117,127.5,111.8,121,111.8C121.1,111.8,121.1,111.8,121,111.8z"
                  />
                </g>
              </g>
            </svg>
            <span class="info-card__cost-item-title">{{ item.CostText }}</span>
          </div>
          <div v-else-if="item.CostText == 'Free day out'" class="info-card__cost-item">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 viewBox="0 0 190.5 190.5" style="enable-background:new 0 0 190.5 190.5;" xml:space="preserve"
            >

              <g id="Group_247" transform="translate(-384 -1411)">
                <path id="Path_57" fill="#B298B0" class="st0" d="M479.2,1411.1c52.6,0,95.2,42.6,95.2,95.2s-42.6,95.2-95.2,95.2s-95.2-42.6-95.2-95.2
                S426.6,1411.1,479.2,1411.1z"
                />
                <g id="Group_234" transform="translate(370.018 1380.779)">
                  <path id="Path_130" fill="#fff" class="st1" d="M130.8,131.9l-11.7-11.7h6.8c3.8,0,6.8,3.1,6.8,6.8C132.7,128.8,132.1,130.6,130.8,131.9z" />
                  <path id="Path_131" fill="#fff" class="st1" d="M90.7,116.9c-2.5-7.4-2.4-15.4,0-22.8l16.5,16.5c0,0.1,0.1,0.3,0.1,0.4c1,2.7,1.7,5.4,2.1,8.2
                  l0.2,0.9h7.1l12.8,12.8c-1.1,0.7-2.4,1.1-3.6,1.1h-15.7v0.9c-0.2,1.7-0.4,3.4-0.8,5l-19.6-19.6h1.9l-0.5-1.9
                  C91.1,118,91,117.4,90.7,116.9z"
                  />
                  <path id="Path_132" fill="#fff" class="st1" d="M138.4,171.5c-0.8,0.6-1.7,1.1-2.7,1.3c-5.2,1.3-10.6,2.1-16,2.1c-3.5,0-7-0.4-10.3-1.4
                  c-2.2-0.7-4.5-1-6.8-0.9c-4.8,0.1-9.6,0.8-14.3,1.9c-3.8,0.9-7.7-0.9-9.6-4.2c-1.7-3.5-1.1-7.7,1.6-10.6
                  c6.3-6.8,10.5-15.3,12-24.4l0.2-0.9H82c-3.8,0.1-7-3-7-6.8c0-0.1,0-0.2,0-0.3c0.1-3.8,3.2-6.8,7-6.8h5.4l21.5,21.5
                  c-1,4.1-2.4,8-4.2,11.8L104,155l1.4,0.2c3.2,0.3,6.3,0.8,9.4,1.6c1.6,0.5,3.3,0.7,4.9,0.7c1.5,0,3-0.1,4.4-0.3L138.4,171.5z"
                  />
                  <path id="Path_133" fill="#fff" class="st1" d="M139.7,170.4L126.3,157c1.6-0.2,3.2-0.6,4.8-1.1c1.4-0.5,2.9-0.5,4.4-0.2
                  c3.1,0.8,5.6,3.2,6.4,6.3C142.6,165,141.8,168.2,139.7,170.4z"
                  />
                  <path id="Path_134" fill="#fff" class="st1" d="M106.5,107.6L91.4,92.5c2.3-5.6,6.2-10.3,11.3-13.6c12.1-7.7,27.8-6,38,4
                  c1.8,1.5,2.8,3.8,2.8,6.1c0.2,2.3-0.5,4.6-2.1,6.3c-1.6,1.6-3.8,2.6-6.1,2.8c-2.3,0-4.5-0.8-6.1-2.4c-4.3-4.6-11.2-5.6-16.7-2.4
                  C107.9,96.6,105.6,102.1,106.5,107.6z"
                  />
                  <path id="Path_135" fill="#fff" class="st1" d="M158.9,167.6l-8.4,8.4c-1.4,1.4-3.7,1.4-5.2,0c0,0,0,0,0,0l-19-19.1L109.4,140L59.6,90.2
                  c-1.4-1.4-1.4-3.7,0-5.2c0,0,0,0,0,0l8.4-8.4c1.4-1.4,3.8-1.4,5.2,0l17.6,17.6l16.5,16.5l22.3,22.3l1.9,1.9l27.5,27.5
                  C160.4,163.8,160.4,166.1,158.9,167.6C158.9,167.6,158.9,167.6,158.9,167.6z"
                  />
                </g>
              </g>
            </svg>
            <span class="info-card__cost-item-title">{{ item.CostText }}</span>
          </div>
        </div>
        <div :class="[featuredCardClass ? 'info-card__heading--large' : '']">
          <h2 class="info-card__heading">{{ item.BannerHeading }}</h2>
          <span class="info-card__arrow" v-if="showArrows">
            <svg xmlns="http://www.w3.org/2000/svg" width="25px" height="15px" viewBox="0 0 56 31.617">
              <path d="M0 15.798a2.25 2.25 0 002.23 2.27h46.19L39 27.738a2.29 2.29 0 000 3.21 2.19 2.19 0 003.15 0l13.21-13.54a2.345 2.345 0 000-3.22L42.15.668a2.19 2.19 0 00-3.15 0 2.29 2.29 0 000 3.21l9.43 9.68H2.23A2.25 2.25 0 000 15.798z" />
            </svg>
          </span>
        </div>
        <div class="info-card__area-tag" v-if="!hideTags">
          <template v-if="intersectedTags">
            {{ intersectedTags.slice(0, 3).join(', ') }}
            <template v-if="intersectedTags.length > 3">...</template>
          </template>
          <template v-else-if="item.PrimaryTag">
            {{ item.PrimaryTag.Name }}
          </template>
        </div>
        <div class="info-card__day-out-description" v-if="item.BannerSubheading">
          {{ item.BannerSubheading }}
        </div>
        <p v-if="item.PrimaryAttractionTypeTag" class="info-card__location">{{ item.PrimaryAttractionTypeTag.Name }}</p>
      </div>
    </a>
  </div>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        },
        defaultSelectedTags: {
            type: Array,
            default: () => []
        },
        hideTags: {
            type: String,
            required: false,
            default: ''
        },
        hierarchicalHeadings: {
            type: Boolean,
            required: false
        },
        showArrows: {
            type: Boolean,
            required: false
        },
        showAngledImage: {
            type: Boolean,
            required: false
        },
        featuredCard: {
            type: Boolean,
            required: false
        }
    },
    computed: {
        intersectedTags() {
            if(this.defaultSelectedTags && this.defaultSelectedTags.length && this.item.Tags.length) {
                const tagList = this.item.Tags.map(x => x.Name)
                const intersection = this.defaultSelectedTags.filter(element => tagList.includes(element))
                return intersection
            }
            return ''
        },
        imageModifier() {
            if(this.showAngledImage) {
                return 'c-image-frame--angled'
            }
            return ''
        },
        contentModifier() {
            if(this.showAngledImage) {
                return 'info-card__content--remove-padding-top'
            }
            return ''
        },
        featuredCardClass() {
            if(this.featuredCard && this.index == 0) {
                return true
            } return false
        }
    }
}
</script>